// Create types
export const DEBTOR_CREATE_ERROR = 'DEBTOR_CREATE_ERROR';
export const DEBTOR_CREATE_LOADING = 'DEBTOR_CREATE_LOADING';
export const DEBTOR_CREATE_SUCCESS = 'DEBTOR_CREATE_SUCCESS';
export const DEBTOR_CREATE_VIOLATIONS = 'DEBTOR_CREATE_VIOLATIONS';
export const DEBTOR_CREATE_RESET = 'DEBTOR_CREATE_RESET';

// Show types
export const DEBTOR_SHOW_ERROR = 'DEBTOR_SHOW_ERROR';
export const DEBTOR_SHOW_LOADING = 'DEBTOR_SHOW_LOADING';
export const DEBTOR_SHOW_RETRIEVED_SUCCESS = 'DEBTOR_SHOW_RETRIEVED_SUCCESS';
export const DEBTOR_SHOW_RESET = 'DEBTOR_SHOW_RESET';

// Update types
export const DEBTOR_UPDATE_RESET = 'DEBTOR_UPDATE_RESET';
export const DEBTOR_UPDATE_UPDATE_ERROR = 'DEBTOR_UPDATE_UPDATE_ERROR';
export const DEBTOR_UPDATE_UPDATE_LOADING = 'DEBTOR_UPDATE_UPDATE_LOADING';
export const DEBTOR_UPDATE_UPDATE_SUCCESS = 'DEBTOR_UPDATE_UPDATE_SUCCESS';
export const DEBTOR_UPDATE_RETRIEVE_ERROR = 'DEBTOR_UPDATE_RETRIEVE_ERROR';
export const DEBTOR_UPDATE_RETRIEVE_LOADING = 'DEBTOR_UPDATE_RETRIEVE_LOADING';
export const DEBTOR_UPDATE_RETRIEVE_SUCCESS = 'DEBTOR_UPDATE_RETRIEVE_SUCCESS';
export const DEBTOR_UPDATE_UPDATE_VIOLATIONS = 'DEBTOR_UPDATE_UPDATE_VIOLATIONS';

// Delete types
export const DEBTOR_DELETE_ERROR = 'DEBTOR_DELETE_ERROR';
export const DEBTOR_DELETE_LOADING = 'DEBTOR_DELETE_LOADING';
export const DEBTOR_DELETE_SUCCESS = 'DEBTOR_DELETE_SUCCESS';
export const DEBTOR_DELETE_RESET = 'DEBTOR_DELETE_RESET';

// List types
export const DEBTOR_LIST_ERROR = 'DEBTOR_LIST_ERROR';
export const DEBTOR_LIST_LOADING = 'DEBTOR_LIST_LOADING';
export const DEBTOR_LIST_RESET = 'DEBTOR_LIST_RESET';
export const DEBTOR_LIST_PAGINATION = 'DEBTOR_LIST_PAGINATION';
export const DEBTOR_LIST_SUCCESS = 'DEBTOR_LIST_SUCCESS';
export const DEBTOR_LIST_ORDER = 'DEBTOR_LIST_ORDER';
export const DEBTOR_LIST_PAGE = 'DEBTOR_LIST_PAGE';

// List documents

export const DEBTOR_DOCUMENT_LIST_ERROR = 'DEBTOR_DOCUMENT_LIST_ERROR';
export const DEBTOR_DOCUMENT_LIST_LOADING = 'DEBTOR_DOCUMENT_LIST_LOADING';
export const DEBTOR_DOCUMENT_LIST_SUCCESS = 'DEBTOR_DOCUMENT_LIST_SUCCESS';
export const DEBTOR_DOCUMENT_LIST_ORDER = 'DEBTOR_DOCUMENT_LIST_ORDER';

export const DEBTOR_FACTORED_INVOICE_LIST_ERROR = 'DEBTOR_FACTORED_INVOICE_LIST_ERROR';
export const DEBTOR_FACTORED_INVOICE_LIST_LOADING = 'DEBTOR_FACTORED_INVOICE_LIST_LOADING';
export const DEBTOR_FACTORED_INVOICE_LIST_SUCCESS = 'DEBTOR_FACTORED_INVOICE_LIST_SUCCESS';
export const DEBTOR_FACTORED_INVOICE_LIST_ORDER = 'DEBTOR_FACTORED_INVOICE_LIST_ORDER';


// WEBPACK FOOTER //
// ./src/store/modules/debtor/mutation-types.js